import {FC, MouseEvent} from 'react'
import ServiceButton from "./ServiceButton";
import {getPrioritizedService, isServiceActive, storeBooking} from "../../lib/booking";
import {getDateStatus} from "../../wordpress/operations/get-date-status";
import {settings} from "../../constants/global";
import {resetDateCarousel} from "../../lib/date-caroussel";
import {postExit} from "../../wordpress/operations/post-exit";

interface Props {
    booking?: Booking,
    buttons:[],
    setBooking: Function
}

const ServiceButtons: FC<Props> = ({ buttons, booking, setBooking }) => {
    const handleAddRemove =  (service:any, event: MouseEvent) => {
        booking.calendar_carousel = resetDateCarousel()

        if(service.url) {
            const session = parseInt(sessionStorage.getItem('mech_session') || '0')
            postExit(session, 'external')
            window.location.href = service.url
            return;
        }

        // Redirect to VBO external booking flow
        for(let i=0; i < settings.vbo.brands.length; i++){
            if(settings.vbo.brands[i] === booking.car.brand) {
                if(service.slug === 'service' || service.slug === 'reparation' || service.slug === 'aterkallelse') {
                    booking.car.vbo = true;
                    if(!booking.code) {
                        const session = parseInt(sessionStorage.getItem('mech_session') || '0')
                        postExit(session, 'vbo')
                        window.open(settings.vbo.endpoint + '&regnr=' + booking.car.reg);
                        return;
                    }
                }
            }
        }

        if(isServiceActive(service.slug, booking)) {
            // Remove booked service from service array
            for(let i = 0; i < booking.serviceArray.length; i++) {
                if(booking.serviceArray[i].slug === service.slug) {
                    booking.serviceArray.splice(i, 1);
                    break;
                }
            }
        }else{
            // Add service to service array
            if(service.slug === 'reparation' || service.slug === 'service') {
                const element = document.getElementById('service-boxes');
                if(element) {
                    window.scrollTo({top: element.getBoundingClientRect().bottom - 80, behavior: 'smooth'});
                }
                //const scrollTo = document.querySelector( '#service-buttons-end' );
                //scrollTo.scrollIntoView( { behavior: 'smooth', block: 'start' } );
            }
            booking.serviceArray.push(service)
        }

        // Update prioritized service
        const prioritizedService = getPrioritizedService(booking.serviceArray)
        booking.booking_flow = prioritizedService.booking_flow
        booking.service = prioritizedService

        // Check if chosen date still is available (after changing service etc.)
        if(booking.date) {
            getDateStatus(booking).then((val) => {
                console.log(val)
                booking.date = val.date_available ? booking.date : ''
                booking.loan_car = 'idle'
                storeBooking(booking, setBooking)
            })
        }

        booking.window.in_booking_flow = false
        for(let i = 0; i < booking.serviceArray.length; i++) {
            if (booking.serviceArray[i].booking_flow === 'window') {
                booking.window.in_booking_flow = true
                booking.booking_flow = 'window'
            }
        }
        storeBooking(booking, setBooking)
    };

    return (
        <>
            <div className="category-content service-container">
                <div id={"service-boxes"} className="service-boxes">
                    {buttons.map((button, i) => (
                    <ServiceButton key={i} service={button} booking={booking} handleAddRemove={handleAddRemove}/>
                    ))}
                    {buttons.length === 0 && (
                       <div className={"no_service_message"} dangerouslySetInnerHTML={{__html:settings.auth.message}}></div>
                    )}
                </div>
            </div>
        </>
    )
};

export default ServiceButtons
